import Vue from 'vue'
import VueRouter from 'vue-router'
import Chat from '../views/Chat.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Chats',
    component: Chat
  },
  {
    path: '/chat/:id',
    name: 'ChatAdmin',
    component: Chat
  },
  {
    path: '/pedido/:id',
    name: 'ChatPedidoAuth',
    component: Chat
  },
  {
    path: '/pedido',
    name: 'ChatPedido',
    component: Chat
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router;